// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__1wJNS","imageUploader":"EGiftCard_imageUploader__QZqhJ"};